import { checkIfResponseSuccess } from 'owa-mail-store';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import { TraceErrorObject } from 'owa-trace';

export default function handleServerResponseSuccessAndError(
    response: SingleResponseMessage | SingleResponseMessage[]
): Promise<void> {
    if (!response) {
        return Promise.reject(createServiceFetchError('500', 'Server returned a null response!'));
    }

    const responseItems = Array.isArray(response) ? response : [response];
    for (const responseItem of responseItems) {
        if (responseItem && !checkIfResponseSuccess(responseItem)) {
            return Promise.reject(
                createServiceFetchError(responseItem.ResponseCode, responseItem.StackTrace)
            );
        }
    }

    return Promise.resolve();
}

function createServiceFetchError(responseCode: string, stackTrace: string): Error {
    const error: TraceErrorObject = new Error(
        `ResponseCode=${responseCode}, Stacktrace=${stackTrace}`
    );
    error.fetchErrorType = 'ServerFailure';
    return error;
}
